export default __webpack_public_path__ + "static/media/zibasazi@2x.b70dcb20.png";